<template>
<div class="ax_select_box">
    <van-field v-model="currentValue" disabled :label="label" right-icon="arrow-down" @click="showBottom = true" :error="error" />
    <van-popup v-model="showBottom" position="bottom">
        <van-picker show-toolbar :columns="options" @cancel="showBottom = false" @confirm="onConfirm" :default-index="defaultIndex" />
    </van-popup>
</div>
</template>

<script>
export default {
    name: "ax-select",
    props: {
        error: [Boolean],
        value: [String, Number],
        label: [String, Number],
        options: [Array]
    },
    data() {
        return {
            currentValue: '请选择',
            currentId: this.value,
            showBottom: false,
            defaultIndex: 0
        }
    },
    methods: {
        onConfirm(value) {
            this.currentValue = value.text;
            this.currentId = value.id;
            this.showBottom = false;
        },
        setDefault() {
            var _this = this;
            this.options.forEach((current, index) => {
                if (current['id'] === this.value) {
                    this.defaultIndex = index;
                    this.currentValue = current['text']
                }
            });
        }
    },
    created() {
        if (this.value) {
            this.setDefault();
        }
    },
    watch: {
        currentValue: function (val, oldVal) {
            this.$emit('input', this.currentId);
        },
        value: function (val, oldVal) {
            if (val !== oldVal) {
                this.currentId = this.value;
            }
        }
    },
}
</script>

<style lang="scss">
.ax_select_box {
    .van-field__control {
        text-align: right;
    }
}

.errors_box .van-cell__title {
    color: #f44;
}
</style>
